/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Constants for streaming payloads.
 */
export enum PayloadConstants {
    MaxPayloadLength = 4096,
    MaxHeaderLength = 48,
    MaxLength = 999999,
    MinLength = 0,
}
